import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Icon } from '@gumtree/ui-library';
// import { buildAdjustDeepLink } from '@gumtree/shared/src/util/adjust-deep-link';
import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';
import {
    BannerContainer,
    BannerCloseButton,
    BannerContentWrap,
    BannerContent,
    AppIcon,
    BannerText,
    BannerTitle,
    BannerSubtitle,
    GetButton,
    gumtreeIconStyle,
} from './app-download-banner.style';
import { getBannerConfig, mapGa4PageTypeToRouteType } from './app-download-banner-config';

interface AppDownloadBannerProps {
    /**
     * Override automatic configuration detection
     * If provided, these props will override the page-based configuration
     */
    nav?: string;
    campaign?: string;
    adgroup?: string;
    creative?: string;
    storageKey?: string;
    /**
     * Banner title text
     */
    title?: string;
    /**
     * Banner subtitle/description text
     */
    subtitle?: string;
}

const AppDownloadBanner: React.FC<AppDownloadBannerProps> = ({
    title = 'Gumtree - Buy & Sell',
    subtitle = 'Open in the Gumtree app',
}) => {
    
    const { baseConfig } = useSelector((state: any) => state);
    const isMobile = baseConfig?.device?.type === 'mobile';
    const ga4PageType = baseConfig?.pageType;
    const isSafari = baseConfig?.isSafari ?? false;

    const routePageType = mapGa4PageTypeToRouteType(ga4PageType);
    const pageConfig = routePageType ? getBannerConfig(routePageType) : undefined;
    const isVisibleDefault = !isSafari && Boolean(pageConfig) && Boolean(pageConfig?.adjustLink) && isMobile;
    const [isVisible, setIsVisible] = useState(isVisibleDefault);

    const handleClose = () => {
        setIsVisible(false);
    };

    const handleGetClick = () => {
        // Build Adjust deep link URL
        const adjustUrl = pageConfig?.adjustLink || '';

        // Track the click
        trackGA4Event({
            event: 'applink_banner_click',
            campaign: pageConfig?.campaign || 'Mobile_Web_Banner',
            adgroup: pageConfig?.adgroup || 'Home_Page',
        });

        window.location.href = adjustUrl;
    };

    if(!isVisible) {
        return null
    }

    return (
        <BannerContainer>
            <BannerCloseButton
                type="button"
                onClick={handleClose}
                aria-label="Close banner"
            >
                <Icon type="clear" size="small" />
            </BannerCloseButton>
            <BannerContentWrap>
                <BannerContent onClick={handleGetClick}>
                    <AppIcon>
                        <Icon css={gumtreeIconStyle} type="gumtree" />
                    </AppIcon>
                    <BannerText>
                        <BannerTitle>{title}</BannerTitle>
                        <BannerSubtitle>{subtitle}</BannerSubtitle>
                    </BannerText>
                </BannerContent>
                <GetButton type="button" onClick={handleGetClick}>
                    Get
                </GetButton>
            </BannerContentWrap>
        </BannerContainer>
    );
};

export default AppDownloadBanner;

